import { WORKOUT_SECTION_KEY } from '../../../model'
import { getCurrentOrCustomerIdProfileSelect } from '../../../../profile/redux/selectors/get-current-or-customer-id'
import updateReduxAction from '../../../../redux/actions/update'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import { saveWorkoutSectionAction } from '../save'
import getByIdWorkoutSectionSelector from '../../selectors/get-by-id'
import getCurrentWorkoutSectionSelect from '../../selectors/get-current'
import updateLocalHasAssociationChangeWorkoutAction
  from '../../../../workout/redux/actions/update-local-has-association-change'

export default function updateWorkoutSectionAction (action) {
  return (dispatch, getState) => {
    const {
      payload,
      type
    } = action
    const {
      key,
      value,
      keys,
      values,
      workoutSection,
      id,
      omitWorkoutUpdate
    } = payload
    // Update the workoutSection
    const newWorkoutSection = (
      workoutSection ||
      getByIdWorkoutSectionSelector(id)(getState()) ||
      getCurrentWorkoutSectionSelect(getState())
    )
    const updates = {
      [WORKOUT_SECTION_KEY.PROFILE_ID]: getCurrentOrCustomerIdProfileSelect(
        getState())
    }
    if (keys) {
      keys.forEach((key, index) => {
        updates[key] = values[index]
      })
    } else {
      updates[key] = value
    }

    const canStandaloneSave = (
      !isNewReduxUtil(newWorkoutSection) &&
      getValueReduxUtil(newWorkoutSection, WORKOUT_SECTION_KEY.PROFILE_ID) ===
      getCurrentOrCustomerIdProfileSelect(getState())
    )

    dispatch(updateReduxAction({
      type,
      payload: {
        path: getPathReduxUtil(newWorkoutSection),
        updates
      }
    }))

    if (omitWorkoutUpdate) {
      return
    }

    if (isNewReduxUtil(newWorkoutSection) || !canStandaloneSave) {
      dispatch(updateLocalHasAssociationChangeWorkoutAction())
    } else if (canStandaloneSave) {
      dispatch(saveWorkoutSectionAction(getIdReduxUtil(workoutSection)))
    }
  }
}
